"use strict";
var ArrayBufferViewCore = require("../internals/array-buffer-view-core");
var apply = require("../internals/function-apply");
var $lastIndexOf = require("../internals/array-last-index-of");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
exportTypedArrayMethod("lastIndexOf", function lastIndexOf(searchElement) {
  var length = arguments.length;
  return apply($lastIndexOf, aTypedArray(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});
